import Vue from "vue";
import { http } from "@/libs/esg-acsp-core-vue-lib/utils/Http";
import { AcspSvgIcon } from "@/libs/esg-acsp-core-vue-lib/components";
import AppContext from "@/libs/esg-acsp-core-vue-lib/utils/AppContext";
import { AcspMessage } from "@/libs/esg-acsp-core-vue-lib/components";
import { Message } from "ant-design-vue";
import { jumpBLogin, jumpBRegister } from "@/utils/utils";
const { Stats } = window; // npm引用改为cdn引用

function initSvgIcon() {
  const requireAll = (requireContext) =>
    requireContext.keys().map(requireContext);
  const req = require.context("../assets/icons", true, /\.svg$/);
  requireAll(req);
  Vue.use(AcspSvgIcon);
}

// eslint-disable-next-line no-unused-vars
export default ({ app, router, store }) => {
  // 埋点
  // Stats.registerCommonParams({
  //   mobile: function () {
  //     return sessionStorage.mobile || "";
  //   },
  // });
  Vue.prototype.$stats = Stats;

  AppContext.init({ app, router, store });
  initSvgIcon();
  AcspMessage.configAntVue(Message);

  http.config.false = true;
  // http.config.baseURL = isDev ? "http://127.0.0.1:8077/" : "";
  // http.config.baseURL = isDev ? "http://100.110.39.126:8077/" : "";
  http.config.handlerDataError = function (data) {
    let { errorCode, errorMessage, config = {} } = data;
    /**
     * 000000 -系统繁忙
     * 000001 - 未登录
     * 000002 - 参数不合法
     * 000008 - 收银台，订单重复支付
     */
    let errorMsg = errorMessage || "系统异常";
    switch (errorCode) {
      case "000001":
        if (config.isToLogin !== false) {
          // 登录已切换(接入B端统一账号) === 跳B端登录页
          jumpBLogin();
          // router.push({
          //   path: "/login",
          //   query: {
          //     redirectUrl: encodeURIComponent(location.href),
          //   },
          // });
        }
        break;
      case "000008": // 收银台已处理
        break;
      case "000014":
        // 登录已切换(接入B端统一账号) === 跳B端登录页
        jumpBLogin();
        break;
      case "000015":
        // 登录账户未绑定(接入B端统一账号) === 跳B端注册页
        jumpBRegister();
        break;
      case "000000":
      case "000002":
      default:
        if (config.showError !== false) {
          AcspMessage.showNotice(errorMsg);
        }
        break;
    }
    // if (["请先完成鉴权", "NOT_AUTH", "NOT_LOGIN"].indexOf(errorCode) != -1) {
    //   // 鉴权失败，跳转到首页
    //   // store.dispatch('logout');
    //   return;
    // }
  };
};
